import { useState } from "react";
import StatusChip from "./StatusChip";
import Swal from "sweetalert2";

// Create a small wrapper component for the cell
export const StatusCell = ({
  row,
  handleStatusChange,
  canChangeStatus = true,
}: {
  row: any;
  handleStatusChange: (id: string, status: string) => void;
  canChangeStatus?: boolean;
}) => {
  const [status, setStatus] = useState(row.original.current_status || "Draft");

  const onChange = (newStatus: string) => {
    if (row.original.is_deleted) {
      Swal.fire({
        text: "You Cannot Change the Status of a Trashed Quotation.",
        icon: "warning",
        confirmButtonText: "Okay!",
        confirmButtonColor: "#d33",
        width: "250px",
        padding: "0.5rem",
        customClass: {
          popup: "swal2-sm-popup",
          confirmButton: "swal2-sm-btn",
        },
      });
      return;
    }
    setStatus(newStatus);
    handleStatusChange(row.original.quotation_id, newStatus);
  };

  // Render non-editable status for deleted quotations
  if (row.original.is_deleted || !canChangeStatus) {
    return (
      <StatusChip
        initialStatus={status}
        onChange={() => {}}
        disabled={true} // optional prop if you want to style differently
      />
    );
  }

  return <StatusChip initialStatus={status} onChange={onChange} />;
};
